export const SomethingWentWrongPage: React.FC = () => {
  return (
    <div className="light text-foreground bg-background min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-danger mb-4">
          Failed to Initialize App
        </h1>
        <p className="text-default-500 mb-4">
          Please check your configuration and try again.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-primary text-white rounded"
        >
          Reload
        </button>
      </div>
    </div>
  );
};
